import AdyenApplePayment from '../../payment/AdyenApplePayment';
import AdyenGooglePayment from '../../payment/AdyenGooglePayment';
import AdyenKlarnaPayment from '../../payment/AdyenKlarnaPayment';
import AdyenPaypalPayment from '../../payment/AdyenPaypalPayment';
import AdyenTwintPayment from '../../payment/AdyenTwintPayment';
import SpayAdyenIdealPayment from '../../payment/SpayAdyenIdealPayment';
import SpayAdyenMobilePayPayment from '../../payment/SpayAdyenMobilePayPayment';

const getCustomNavigationButton = (paymentOptionKey?: string) => {
  if (!paymentOptionKey) {
    return undefined;
  } else if (paymentOptionKey === 'adyen_paypal') {
    return <AdyenPaypalPayment />;
  } else if (paymentOptionKey === 'spay_adyen_mobilepay') {
    return <SpayAdyenMobilePayPayment />;
  } else if (paymentOptionKey === 'spay_adyen_ideal') {
    return <SpayAdyenIdealPayment />;
  } else if (['adyen_klarna_paylater', 'adyen_klarna_paynow', 'adyen_klarna_installments'].includes(paymentOptionKey)) {
    return <AdyenKlarnaPayment />;
  } else if (['adyen_twint', 'spay_adyen_twint'].includes(paymentOptionKey)) {
    return <AdyenTwintPayment />;
  } else if (['adyen_apple_pay', 'spay_adyen_apple_pay'].includes(paymentOptionKey)) {
    return <AdyenApplePayment />;
  } else if (['adyen_google_pay', 'spay_adyen_google_pay'].includes(paymentOptionKey)) {
    return <AdyenGooglePayment />;
  } else {
    return undefined;
  }
};

export default getCustomNavigationButton;
